





import { Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax'
import AbpBase from '../../lib/abpbase'
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend');
import 'echarts/lib/chart/line'
@Component({})
export default class BarLine extends AbpBase{
    @Prop({type:Object}) value:Object;
    initData:any = {
        app:{},
        data:{}
    }
    //计算最大值
    calMax(arr:any) {
        let max = 0;
        arr.forEach((el:any) => {
            if (!(el === undefined || el === '')) {
                if (max < el) {
                    max = el;
                }
            }
        })
        let maxint = Math.ceil(max / 9.5);//不让最高的值超过最上面的刻度
        let maxval = maxint * 10;//让显示的刻度是整数
        return maxval;
    }
    //计算最小值
    calMin(arr:any) {
        let min = 0;
        arr.forEach((el:any) => {
            el.forEach((el1:any) => {
            if (!(el1 === undefined || el1 === '')) {
                if (min > el1) {
                    min = el1;
                }
            }
        })
        })
        let minint = Math.floor(min / 10);
        let minval = minint * 10;//让显示的刻度是整数
        return minval;
    }
    drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('myChartLine'));
        // 绘制图表
        var colors = ['#37a2da', '#32c5e9', '#67e0e3','#9fe6b8','#ffdb5c','#ff9f7f'];
        myChart.setOption({
            color: colors,

            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                }
            },
            grid: {
                right: '5%',
                left:'5%',
            },
            legend: {
                data:['项目数量','项目总经费','已收款金额','未收款金额','开票未收款金额','利润']
            },
            xAxis: [
                {
                    type: 'category',
                    axisTick: {
                        alignWithLabel: true
                    },
                    data: this.initData.data.name
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: '项目数量',
                    position: 'left',
                    axisLine: {
                        lineStyle: {
                            color: colors[0]
                        }
                    },
                    axisLabel: {
                        formatter: '{value} 个'
                    },
                    max:this.calMax(this.initData.data.projectCount),
                    min: this.calMin([this.initData.data.projectCount]),
                    interval: (this.calMax(this.initData.data.projectCount) - this.calMin([this.initData.data.projectCount])) / 5
                },
                {
                    type: 'value',
                    name: '项目总经费',
                    position: 'right',
                    axisLine: {
                        lineStyle: {
                            color: colors[1]
                        }
                    },
                    axisLabel: {
                        formatter: '{value} 元'
                    },
                    max:this.calMax(this.initData.data.projectAmountTotal),
                    min:this.calMin([this.initData.data.projectAmountTotal,this.initData.data.ticketUnReceiveAmountTotal]),
                    interval: (this.calMax(this.initData.data.projectAmountTotal) - this.calMin([this.initData.data.projectAmountTotal,this.initData.data.ticketUnReceiveAmountTotal])) / 5
                }
            ],
            series: [
                {
                    name:'项目数量（个）',
                    type:'line',
                    yAxisIndex: 0,
                    barWidth:20,
                    data:this.initData.data.projectCount
                },
                {
                    name:'项目总经费（元）',
                    type:'bar',
                    yAxisIndex: 1,
                    barWidth:20,
                    data:this.initData.data.projectAmountTotal
                },
                {
                    name:'已收款（元）',
                    type:'bar',
                    yAxisIndex: 1,
                    barWidth:20,
                    data:this.initData.data.receivedAmountTotal
                },
                {
                    name:'未收款（元）',
                    type:'bar',
                    yAxisIndex: 1,
                    barWidth:20,
                    data:this.initData.data.unReceivedAmountTotal
                },
                {
                    name:'开票未收款（元）',
                    type:'bar',
                    yAxisIndex: 1,
                    barWidth:20,
                    data:this.initData.data.ticketUnReceiveAmountTotal
                },
                {
                    name:'利润（元）',
                    type:'bar',
                    yAxisIndex: 1,
                    barWidth:20,
                    data:this.initData.data.profitAmount
                }
            ]
        });
    }
    mounted(){
        this.drawLine();
        window.addEventListener('resize', () => {
            echarts.init(document.getElementById('myChart')).resize(); //初始化的
        } )
    }
    @Watch('value',{ immediate: true,deep: true})
    ChangeBar(newValue:any,oldValue:any){
        this.initData.data = newValue;
        this.$nextTick( ()=>{
            this.drawLine();
        } )
    }
}
